import { render, staticRenderFns } from "./assemblyItemDialog.vue?vue&type=template&id=8bf44fae&"
import script from "./assemblyItemDialog.vue?vue&type=script&lang=js&"
export * from "./assemblyItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports